import React, { createContext, useState, useContext } from 'react';

export const SUPPORTED_LANGUAGES = ['sv', 'en'];

const loadTranslations = (lang) => {
  try {
    return require(`../i18n/${lang}.json`);
  } catch {
    return require('../i18n/sv.json');
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('sv');

  const t = (key) => {
    const translations = loadTranslations(language);
    return translations[key] ?? key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'sv' ? 'en' : 'sv');
  };

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
